'use strict';
const $ = jQuery.noConflict();
$(function() {

	const stepsBlock = {

		init: function() {
			this.cacheDOM();
			this.bindObserver();
		},

		cacheDOM: function() {
			this.$panels = $('.js-steps-block').closest('.steps-block__panel');
		},

		bindObserver: function() {
			if (!this.$panels.length || !('IntersectionObserver' in window)) {
				this.$panels.addClass('is-visible');
				return;
			}

			const observer = new IntersectionObserver((entries, obs) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						entry.target.classList.add('is-visible');
						obs.unobserve(entry.target);
					}
				});
			}, {threshold: 0.35});

			this.$panels.each(function() {
				observer.observe(this);
			});
		},

	};

	stepsBlock.init();
});
